import Inputs from './inputs'
import Sections from './sections'

const Questions = () => {
  return (
    <>
      <Inputs />
      <Sections />
    </>
  )
}

export default Questions
